export const knownAccessorialsGroups: Record<number, string> = {
  [1]: 'Pickup Charges',
  [2]: 'Delivery Charges',
  [3]: 'Shipment Charges'
}
